import { getParametrizedUrl } from '@x_x_x/utils';

import { URLS_API } from '@constants';

import { BaseApi, IRequestOptions } from '../BaseApi';

import {
	IApiWeightLogCreateRequestParams,
	IApiWeightLogCreateRequestBody,
	IApiWeightLogCreateResponseData,

	IApiWeightLogUpdateRequestParams,
	IApiWeightLogUpdateRequestBody,
	IApiWeightLogUpdateResponseData,
} from './types';

export class WeightLogApi extends BaseApi {

	async create(options: IRequestOptions<IApiWeightLogCreateRequestParams, IApiWeightLogCreateRequestBody>) {
		const { body } = options;

		return this.post<IApiWeightLogCreateRequestBody, IApiWeightLogCreateResponseData>({
			url: getParametrizedUrl(URLS_API.WEIGHT_LOG),
			data: body,
		});
	}

	async update(options: IRequestOptions<IApiWeightLogUpdateRequestParams, IApiWeightLogUpdateRequestBody>) {
		const { params, body } = options;

		return this.put<IApiWeightLogUpdateRequestBody, IApiWeightLogUpdateResponseData>({
			url: getParametrizedUrl(URLS_API.WEIGHT_LOG_ITEM, params as unknown as Record<string, string>),
			data: body,
		});
	}

}
